import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';

const ContactInfo = ({ contactMedia, contactIcon }) => (
  <div className="affiliate__contact-info-contact">
    <Icon size="normal" name={contactIcon} />
    <span>{contactMedia}</span>
  </div>
);

ContactInfo.propTypes = {
  contactMedia: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  contactIcon: PropTypes.string.isRequired,
};

export default ContactInfo;
